// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3s174","unreadBadge":"styles_unreadBadge__2AZRn","modalContent":"styles_modalContent__K0P2U","modal":"styles_modal__Omo84"};